// Module
var code = "<a href=\"{{$ctrl.href}}\" class=\"vui-navigations-profile tw-block\" title=\"{{$ctrl.getFullName()}}\">\n    <img ng-src=\"{{$ctrl.getUserAvatar()}}\"\n         alt=\"Avatar\" class=\"vui-avatar\">\n</a>";
// Exports
module.exports = code;